import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type PaginationState, type SortingState } from '@tanstack/react-table'
import { useState } from 'react'

import CoverageAuditLogsTable, { getCoverageAuditLogsQueryKey } from 'components/brokers/coverage_audit_logs/CoverageAuditLogsTable'
import CoverageAuditLogsContext from 'components/context/CoverageAuditLogsContext'

type CoverageAuditLogsMembersViewProps = {
  memberId: string
  availableReasons?: string[]
}

const CoverageAuditLogsMembersViewImpl = ({
  memberId,
  availableReasons,
}: CoverageAuditLogsMembersViewProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  })
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'created_at', desc: true },
  ])

  return (
    <CoverageAuditLogsContext.Provider
      value={{
        getCoverageAuditLogsQueryKey: getCoverageAuditLogsQueryKey({
          filters: { member_ids: [memberId] },
          pagination,
          sorting,
        }),
      }}
    >
      <div className='flex-col w-full h-full space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
        <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
          <div className='heading-md'>Coverage Audit Logs</div>
        </div>
        <CoverageAuditLogsTable
          filters={{ member_ids: [memberId] }}
          setFilters={() => {}}
          pagination={pagination}
          setPagination={setPagination}
          sorting={sorting}
          setSorting={setSorting}
          availableReasons={availableReasons}
        />
      </div>
    </CoverageAuditLogsContext.Provider>
  )
}

const CoverageAuditLogsMembersView = (props: CoverageAuditLogsMembersViewProps) => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <CoverageAuditLogsMembersViewImpl {...props} />
    </QueryClientProvider>
  )
}

export default CoverageAuditLogsMembersView
